(() => {
  if (document.documentElement.dataset.boaDialogsBound) return;
  document.documentElement.dataset.boaDialogsBound = 'true';
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-boa-dialog]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.boaDialog);
      if (dialog instanceof HTMLDialogElement) dialog.showModal();
      return;
    }
    const close = event.target.closest('[data-boa-close]');
    if (close) close.closest('dialog')?.close();
    if (event.target.matches('dialog.boa-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
})();
